import { analytics } from "./index";

// Meta Pixel for the ticket funnel. Disabled (no-op, no script loaded) unless
// REACT_APP_META_PIXEL_ID is set at build time, and loads only after the user accepted the
// analytics banner. The backend sends the same Purchase through the Conversions API with
// event_id "purchase_<orderId>"; reusing that id here lets Meta count it once.
// Never throws.

const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;

let loaded = false;

const allowed = () =>
  !!PIXEL_ID && typeof window !== "undefined" && !analytics.isStaffPage() && analytics.getConsent() === "granted";

function init() {
  try {
    if (loaded || !allowed()) return;
    loaded = true;
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    /* eslint-enable */
    window.fbq("init", PIXEL_ID);
    window.fbq("track", "PageView");
  } catch {
    // tracking must never break the app
  }
}

const cookie = (name) => {
  try {
    const m = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
    return m ? decodeURIComponent(m[1]) : undefined;
  } catch {
    return undefined;
  }
};

// Browser ids the backend needs to match the server event to this visitor.
export function getMetaIds() {
  if (!allowed()) return {};
  const fbp = cookie("_fbp");
  let fbc = cookie("_fbc");
  try {
    const fbclid = new URLSearchParams(window.location.search).get("fbclid");
    if (!fbc && fbclid) fbc = `fb.1.${Date.now()}.${fbclid}`;
  } catch {
    // ignore
  }
  return { ...(fbp ? { fbp } : {}), ...(fbc ? { fbc } : {}) };
}

// Fires once per order per browser tab session.
export function trackPurchase({ orderId, value, currency = "INR", productId, quantity }) {
  try {
    if (!orderId || !(Number(value) > 0)) return;
    init();
    if (!window.fbq) return;
    const key = `ota_meta_purchase_${orderId}`;
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, "1");
    window.fbq(
      "track",
      "Purchase",
      { value: Number(value), currency, content_type: "product", content_ids: productId ? [productId] : undefined, num_items: quantity },
      { eventID: `purchase_${orderId}` },
    );
  } catch {
    // tracking must never break the app
  }
}

export const metaPixel = { init, getMetaIds, trackPurchase };
